import $ from "jquery";
import {bindActionCreators} from "redux";
import DropdownTemplateView from "../../DropdownTemplateView";
import {ALL_FILTER, COMPLETED_FILTER, isAll, isOnlyCompletedType, isOnlyOpenType, OPEN_FILTER} from "../../workflowStatus/components/statusFilter/utils";
import {getTaskStatusFilter} from "../common/selectors";
import {applyTaskStatusFilterAction} from "../common/actions";
import {connect} from "../../redux/utils";
import {getWorkflowStatuses} from "../../entities/selectors";


class StatusFilterMenu extends DropdownTemplateView {
    constructor({
        onFilterChange = () => {},
    }) {
        super();

        this.state = {
            filter: OPEN_FILTER
        };

        this.actions = {
            onFilterChange,
        }

        this.onStateChanged(() => this.updateView());
    }

    templateHtml() {
        return "<div class='dropdownContainer statusFilterMenu'>" +
               "  <div class='item all'><%-allLabel%></div>" +
               "  <div class='item open'><%-openLabel%></div>" +
               "  <div class='item completed'><%-completedLabel%></div>" +
               "</div>";
    }

    afterRender() {
        this.findAndBindClick(".all", () => {
            this._itemClick(ALL_FILTER)
        });
        this.findAndBindClick(".open", () => {
            this._itemClick(OPEN_FILTER)
        });
        this.findAndBindClick(".completed", () => {
            this._itemClick(COMPLETED_FILTER)
        });
    }

    updateView() {
        this.$el.toggleClass("all", isAll(this.state.filter));
        this.$el.toggleClass("open", isOnlyOpenType(this.state.filter));
        this.$el.toggleClass("completed", isOnlyCompletedType(this.state.filter));
    }

    showAt($element, positionParams, onHideCb = () => {}) {
        DropdownTemplateView.prototype.showAt.call(this, $element, positionParams);
        this.onHideCb = onHideCb;
    }

    messageKeys() {
        return {
            allLabel: "task.list.status_filter.all",
            openLabel: "task.list.status_filter.open",
            completedLabel: "task.list.status_filter.completed"
        }
    }

    onHide() {
        super.onHide()
        this.onHideCb()
    }

    _itemClick(filter) {
        this.setState({
            filter: filter
        })
        this.actions.onFilterChange(this.state.filter);
        this.hide();
    }
}

let instance = null
export const getInstance = () => {
    if (!instance) {
        instance = new SimpleStatusFilterMenuConnected({
        }).init($("body"))
    }
    return instance
}

const SimpleStatusFilterMenuConnected = connect(
    state => ({
        filter: getTaskStatusFilter(state),
        statuses: Object.values(getWorkflowStatuses(state)),
    }),
    dispatch => ({
        onFilterChange: bindActionCreators(applyTaskStatusFilterAction, dispatch),
    })
)(StatusFilterMenu)



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/StatusFilterMenu.js